export const PATCH_IMPORTS = {
  bear_patch: () => import('../../../../assets/patches/bear_patch.png'),
  cobra_patch: () => import('../../../../assets/patches/cobra_patch.png'),
  delta_earth_patch: () =>
    import('../../../../assets/patches/delta_earth_patch.png'),
  dragon_patch: () => import('../../../../assets/patches/dragon_patch.png'),
  hammer_patch: () => import('../../../../assets/patches/hammer_patch.png'),
  hydra_patch: () => import('../../../../assets/patches/hydra_patch.png'),
  knight_patch: () => import('../../../../assets/patches/knight_patch.png'),
  pegasus_patch: () => import('../../../../assets/patches/pegasus_patch.png'),
  octopus_patch: () => import('../../../../assets/patches/octopus_patch.png'),
  owl_patch: () => import('../../../../assets/patches/owl_patch.png'),
  ssc_patch: () => import('../../../../assets/patches/ssc_patch.png'),
  griffon_patch: () => import('../../../../assets/patches/griffons_patch.png'),
  stars_patch: () => import('../../../../assets/patches/stars_patch.png'),
  shark_patch: () => import('../../../../assets/patches/shark_patch.png'),
  sword_patch: () => import('../../../../assets/patches/sword_patch.png'),
  tiger_patch: () => import('../../../../assets/patches/tiger_patch.png')
};

const PATCH_ALIASES = {
  griffons_patch: 'griffon_patch'
};

export const PATCH_CSS_MARGIN_TOP = {
  tiger_patch: -16,
  ssc_patch: -16,
  bear_patch: -28,
  owl_patch: -28
};

const stripToBaseName = (value) => {
  if (!value) return null;
  const base = String(value)
    .split('/')
    .pop()
    .split(/[?#]/)[0]
    .replace(/\.[a-z0-9]+$/i, '')
    .replace(/-\d+$/, '');
  return base || null;
};

export const resolvePatchKey = (fileName, patchImageUrl) => {
  const candidates = [
    stripToBaseName(fileName),
    stripToBaseName(patchImageUrl)
  ].filter(Boolean);

  for (const candidate of candidates) {
    const key = PATCH_ALIASES[candidate] || candidate;
    if (PATCH_IMPORTS[key]) return key;
  }

  return null;
};

export const getPatchClass = (patch) => {
  const key = resolvePatchKey(patch?.file, patch?.image);

  const name = key
    ? key.replace(/_patch$/, '').replace(/_/g, '-')
    : (patch?.slug || '')
        .toLowerCase()
        .replace(/[^a-z0-9]+/g, '-')
        .replace(/^-+|-+$/g, '')
        .replace(/^the-/, '');

  return name ? `patch-${name}` : 'patch-default';
};

export const getPatchCanvasOffsetY = (fileName, patchImageUrl) => {
  const key = resolvePatchKey(fileName, patchImageUrl);
  const cssMarginTop = key ? PATCH_CSS_MARGIN_TOP[key] : undefined;

  return cssMarginTop ? cssMarginTop / 2 : 0;
};
